var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMissionThree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 44,
    viewBox: "0 0 87 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90771 34.3028C10.7458 23.5175 15.7323 13.1535 22.896 13.7071M59.6785 42.7518L50.7213 35.1069M50.7213 35.1069L30.9521 18.2339C30.087 17.3995 29.2583 16.6905 28.4611 16.0984C27.5765 15.4414 26.7308 14.9283 25.917 14.5475C24.8609 14.0532 23.8588 13.7815 22.896 13.7071M50.7213 35.1069C59.5819 24.9177 60.1945 20.8676 64.9255 20.9965C65.9109 21.0233 67.075 21.2314 68.5296 21.6031L70.8616 22.9045L74.0416 24.679M86.1788 31.4518L74.0416 24.679M22.896 13.7071C29.0918 7.05478 36.9412 -0.201048 51.4103 1.64827C63.8655 4.8788 71.4446 12.6022 74.0416 24.679",
    stroke: "white",
    strokeWidth: 2.64641,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMissionThree);
export default __webpack_public_path__ + "static/media/iconMissionThree.15d66d5b625e0faef610fbbc045e3666.svg";
export { ForwardRef as ReactComponent };